declare namespace angular {
    export interface IFilterService {
        (name: 'accentInsensitiveOrderBy'): app.support.IFilterAccentInsensitiveOrderBy;
    }
}

namespace app.support {

    export interface IFilterAccentInsensitiveOrderBy {
        <T>(array: T[], expression: string, reverse?: boolean): T[];
    }

    /** @ngInject */
    function filterAccentInsensitiveOrderBy($filter: ng.IFilterService, $parse: ng.IParseService) {
        return (array, expression, reverse) => {
            return $filter("orderBy")(array, (item) => {
                return _.deburr($parse(expression)(item));
            }, reverse);
        }
    }

    angular.module('app.support').filter('accentInsensitiveOrderBy', filterAccentInsensitiveOrderBy);
}